import utilService from '../../services/utilService';

enum InsightsType {
    no_insights='noInsights',
    no_evaluation_data='noEvaluationData',
    accuracy_error='accuracyError',
    accuracy_in_progress='accuracyInProgress',
    low_score_sub_component='lowF1ClassSubComponent',
    few_instances_sub_component='fewInstancesSubComponent',
    low_score_classification='lowF1ClassClassification',
    few_instances_classification='FewInstancesClassification'
}

const _MAIN_TITLES = {
    systemName: 'VI Studio',
    systemNameFull: 'Visual Intelligence Studio',
    attributes: 'Attributes',
    tags: 'Tags',
    labels: 'Components',
    versionTtile: 'Version',
    trainings: 'trainings',
    projects: 'Projects',
    versions: 'Versions',
    accuracy: 'Accuracy',
    feature: 'AI Analysis',
    features: 'AI Analyses',
    classes: 'Queries',
    deploy: 'Launchpad',
    annotations: 'Elements',
    account: 'account',
    mainAccount: 'Production',
    acClass: 'object',
    autoClassification: 'AI Generated Project',
    manualRefinement: 'Fine Tune',
    predictions: 'Predictions',
    annotationsAnnotations: 'Annotations'

};

const _SYSTEM_TITLES = {
    ..._MAIN_TITLES,
    LastModified: 'Last modified',
    tableNumberOfFiles: 'Total Files',
    completeStatus: 'Done',
    trackingStatus: 'Tracking',
    trackedStatus: 'Confirm Images',
    tagsAndAttributes: `${_MAIN_TITLES.tags} & ${_MAIN_TITLES.labels}`,
    labelsAndAttributes: `${_MAIN_TITLES.labels} & ${_MAIN_TITLES.attributes}`,
    ProjectDetails: 'Project Details',
    leaveWithoutSaveModal: {
        title: `You are about to cancel the ${_MAIN_TITLES.feature} creation`,
        subTitle: 'Would you like to save a draft instead and leave?'
    },
    newFolderTitle: 'New Folder',
    newFolderOnFileFolder: 'Folders cannot be created side by side with files',
    startTagging: 'Start Tagging',
    tokenExpireModal: {
        title: 'Session has expired',
        subTitle: 'You need to login again to continue working',
        button: 'Log in'
    },
    projectName: `${utilService.removeLastChar(_MAIN_TITLES.projects, 1)} Name`,
    predefinedTags: `Predefined ${_MAIN_TITLES.tags} groups`,
    predefinedLabels: `Predefined ${_MAIN_TITLES.labels} groups`,
    predefinedAttributes: `Predefined ${_MAIN_TITLES.attributes} groups`,
    customTagging: `Custom ${_MAIN_TITLES.tags.toLowerCase()}`,
    noAnnotations: 'Highlight the component by using the rectangle from the canvas menu',
    applyToAll: 'Add Current Tags to All',
    validate: 'Save',
    version: 'Training version',
    selectAnIndustryDetail: `Select from a predefined ${_MAIN_TITLES.tags.toLowerCase()} or create a custom ${utilService.removeLastChar(_MAIN_TITLES.tags.toLowerCase())}`,
    selectAnIndustry: 'Select',
    labelsInfo: 'What parts of the object do you want to identify? Example: LED status indicator, power port',
    attributeInfo: 'What are the different states of the component? Examples: plugged in, unplugged, on, off, red, yellow, green.',
    selectTag: `-Select ${_MAIN_TITLES.tags} (optional)`,
    optionalAttribute: `${utilService.removeLastChar(_MAIN_TITLES.attributes, 1)} (optional)`,
    trainingPreparation: `Create New ${_MAIN_TITLES.feature}`,
    trainingPreparationOld: `${_MAIN_TITLES.feature} - Training`,
    featureNameTitle: `${_MAIN_TITLES.feature} Name`,
    featureTypeTitle: `${_MAIN_TITLES.feature} Level`,
    featurePlaceholderInput: `Type a ${_MAIN_TITLES.feature} name`,
    createTraining: 'Submitting for training',
    subCreateTraining: 'Please wait until the training will start',
    createTagging: 'Loading',
    subCreateTagging: 'Preparing the tagging process',
    deployTitle: `${_MAIN_TITLES.deploy} ${_MAIN_TITLES.feature}`,
    selectDeployProject: `Select a ${utilService.removeLastChar(_MAIN_TITLES.projects.toLowerCase(), 1)} name`,
    selectDeployFeature: `Select a ${_MAIN_TITLES.feature} name`,
    selectDeployAccount: `Select a ${_MAIN_TITLES.account} name`,
    selectDeployVersion: `Select a ${utilService.removeLastChar(_MAIN_TITLES.versions.toLowerCase(), 1)} number`,
    tooLongProject: `${utilService.removeLastChar(_MAIN_TITLES.projects, 1)} name is too long`,
    tooLongTags: `${utilService.removeLastChar(_MAIN_TITLES.tags, 1)} name is too long`,
    tooLongLabels: `${utilService.removeLastChar(_MAIN_TITLES.labels, 1)} name is too long`,
    tooLongAttributes: `${utilService.removeLastChar(_MAIN_TITLES.attributes, 2)} name is too long`,
    tooLongFolder: 'Folder name is too long',
    tooLongFeature: `${_MAIN_TITLES.feature} name is too long`,
    createProjectData: `Create new data ${utilService.removeLastChar(_MAIN_TITLES.projects.toLowerCase(), 1)}`,
    ProjectDetailsSummary: `${utilService.removeLastChar(_MAIN_TITLES.projects, 1)} details summary`,
    noDisplayFeatures: `No ${_MAIN_TITLES.feature} available`,
    noDisplayVersions: `No ${utilService.removeLastChar(_MAIN_TITLES.versions.toLowerCase(), 1)} available`,
    noDisplayQueries: 'No query available',
    noDisplayTrainings: `No ${utilService.removeLastChar(_MAIN_TITLES.trainings.toLowerCase(), 1)} available`,
    emptyFolder: 'Empty folder',
    switchFeatureType: `Change ${_MAIN_TITLES.feature} type`,
    subSwitchFeatureType: `This action will delete all the ${_MAIN_TITLES.labels.toLowerCase()} and ${_MAIN_TITLES.attributes.toLowerCase()}. Would you like to continue?`,
    classDelete: `You are about to delete 1 ${utilService.removeLastChar(_MAIN_TITLES.classes.toLowerCase(), 3)}y`,
    classDeleteSub: `Are you sure you want to permanently delete this ${utilService.removeLastChar(_MAIN_TITLES.classes.toLowerCase(), 3)}y?`,
    classDeleteAll: `You are about to delete all ${_MAIN_TITLES.classes.toLowerCase()}`,
    classDeleteSubAll: 'Deleting classes cannot be undone. Are you sure?',
    classInfo: `To add ${_MAIN_TITLES.classes.toLowerCase()}, please select a ${_MAIN_TITLES.feature} type first`,
    addClass: `+ Add ${utilService.removeLastChar(_MAIN_TITLES.classes.toLowerCase(), 3)}y`,
    addClassId: `Add ${utilService.removeLastChar(_MAIN_TITLES.classes.toLowerCase(), 3)}y`,
    uploadDone: 'Images and videos upload has finished',
    uploadNotDone: 'Do not close the window until the upload is completed',
    inProcess: 'In progress',
    deployError: `Failed to activate the ${_MAIN_TITLES.feature}`,
    deployErrorSub: 'Make sure it is not activated already and try again',
    inProcessDeploy: 'Model is being Launched. Please wait, it may take several minutes to complete',
    applyTags: 'Add Current Tags to All',
    applyTagsSub: `The current ${_MAIN_TITLES.tags.toLowerCase()} list will be added to all the images in the current view (including the filtered ones).
Existing Tags will not be removed.
Note - that you will need to review all the images / videos again and confirm the change.
Would you like to proceed?`,
    deploySubTitle: `Active ${_MAIN_TITLES.features} - `,
    annotationsListList: `${_MAIN_TITLES.annotations}`,
    classification: `Image Level (${_MAIN_TITLES.tags.toLowerCase()})`,
    Classification: `Image Level (${_MAIN_TITLES.tags.toLowerCase()})`,
    subComponent: `${_MAIN_TITLES.labels} Level`,
    SubComponent: `${_MAIN_TITLES.labels} Level`,
    logout: 'Logout',
    copied: 'Copied to clipboard',
    trackAgain: 'Track Again',
    itemsSelected: 'item(s) selected',
    backToProject: 'Back to folder -',
    errorModalDefault: 'Operation could not be completed',
    errorModalDefaultSub: 'Please try again. If the problem persists - please contact your System Administrator',
    wereDeleted: 'were deleted',
    wasDeleted: 'was deleted',
    deleteFolderOrFileSub: 'cannot be undone. All the data in the folders will be permanently deleted. Are you sure you want to continue?',
    deployExplanation: `Welcome to VI ${_MAIN_TITLES.deploy}. Use the ${_MAIN_TITLES.deploy.toLowerCase()} to create & manage your AI Analyses versions by choosing which version should be active and available for analysis requests`,
    clickHereHelp: 'Click here',
    helpSub: 'for more information about',
    trainingInsightsToolTip: 'Click to see the insights',
    trainingInsightsTitle: `${_MAIN_TITLES.feature} Insights & Feedback`,
    noInsights: 'No insights to show',
    noEvaluationData: 'No evaluation data',
    accuracyError: 'Error in accuracy process',
    accuracyInProgress: 'Accuracy process still in progress',
    folderSameName: 'Sub folder name already exist',
    folderRenameToolTip: 'Click to rename',
    insightsListTitleTrainingBig: 'Training data feedback',
    insightsListTitleTraining: 'Please review the lower scores classes below. It is recommended to add more images to the training data set:',
    insightsListTitleTrainingSub: `It is also recommended to review that the ${_MAIN_TITLES.annotations.toLowerCase()} were properly annotated in training and evaluation sets.`,
    insightsListTitleEvaluation: 'Sorry! There isn\'t enough data for proper evaluation. Upload at least 40 images per class',
    insightsListTitleEvaluationBig: 'Evaluation data feedback',
    insightsNumOfImages: 'evaluated based on ',
    featureNameExistsError: `${_MAIN_TITLES.feature} name already exists`,
    preTrainingButton: 'Validate & Train',
    draftToggleTitle: 'saved as draft Successfully',
    PreEvaluationMainTitle: 'Assets evaluation',
    lastAnnotationsTitle: 'Copy elements from previous image',
    deleteSelected: 'Delete Selected',
    startTraining: 'Start Training',
    evaluationDataTitle: 'Evaluation Data',
    trainingDataTitle: 'Training Data',
    newTraining: 'Train Again',
    evaluateBtn: 'Evaluate',
    trainingFolderTitle: 'Images and Videos in this section will be used for AI Analysis (model) training purposes',
    evaluationFolderTitle: 'Images and Videos in this section will be used to measure the accuracy (evaluate) the AI Analysis (model). They should be different from the Training ones',
    launchpadPopUpTitle: 'Caution!',
    launchpadPopUpSubTitle: 'You are about to make a change in Production, in the following AI Analysis:',
    launchpadPopUpSubTitleConfirmTitle1: 'Please confirm the change by typing',
    launchpadPopUpSubTitleConfirmTitle2: 'in the box below',
    autoClassifierProjectTitle: 'AI Generated Project',
    regularProjectTitle: 'New Project',
    addClassTitle: `Add ${utilService.capitalize(_MAIN_TITLES.acClass)}`,
    addClassInput: `${utilService.capitalize(_MAIN_TITLES.acClass)} Name`,
    addClassBtn: `Add ${utilService.capitalize(_MAIN_TITLES.acClass)}`,
    updateClassBtn: 'Update',
    deleteClass: `DELETE ${_MAIN_TITLES.acClass.toUpperCase()}`,
    addClassInputSubTitleLine1: 'Prompting the AI to generate a visual model is simple.',
    addClassInputSubTitleLine2: `1. Name the ${_MAIN_TITLES.acClass} you would like the AI to identify.`,
    addClassInputSubTitleLine3: `2. Submit reference images of the ${_MAIN_TITLES.acClass} The AI will monitor your TechSee Live sessions for similar images and then build your AI model.`,
    referenceImages: 'Reference images',
    dragAndDrop: 'Drag and drop or click to ',
    upload: 'Upload',
    createNewAutoProjectTitle: 'Setup AI Generated Project',
    autoProjectMandatoryNameAlert: 'Specify a project name',
    autoProjectNameLabel: 'Project Name',
    autoProjectEmailLabel: 'Project manager email. This address will be notified as the project progresses.',
    autoProjectDescriptionLabel: 'Project description',
    autoProjectSaveDraftBtn: 'Save Draft',
    autoProjectStartBtn: `${_MAIN_TITLES.autoClassification}`,
    autoAddClass: `Start ${_MAIN_TITLES.autoClassification}`,
    autoProjectConfirmStartBtn: 'Confirm & Start',
    invalidProjectNameInputError: 'Project name should contain letters, digits, \'_\' or \'-\' only',
    missingProjectNameInputError: 'Missing Project Name: mandatory field',
    invalidClassNameInputError: `Invalid ${_MAIN_TITLES.acClass} name`,
    missingClassNameInputError: `Missing ${_MAIN_TITLES.acClass} name`,
    invalidEmailInputError: 'Invalid Email Format: Please enter a valid email address.',
    ToManyEmailsEmailInputError: 'Email Limit Exceeded: Maximum of 5 email addresses allowed.',
    autoProjectNameExistError: 'A project with this name already exists',
    autoProjectFeatureNameExistError: 'An AI Analysis with this name already exists',
    classListEmptyTitle: `There are no ${_MAIN_TITLES.acClass}s in this project. To get started, please add an ${_MAIN_TITLES.acClass}.`,
    autoProjectConfirmationWarning: 'Please review and confirm the project details below.',
    autoProjectConfirmationEmailTitle: 'Emails for updates',
    autoProjectConfirmationNameTitle: 'Project Name',
    autoProjectConfirmationClassesTitle: `${utilService.capitalize(_MAIN_TITLES.acClass)}s`,
    backToProjectBtn: 'Back to project',
    backToProjectsBtn: 'Back to projects',
    autoProjectStatusPageStopBtn: 'Stop',
    autoProjectStatusPagePauseBtn: 'Pause Collector',
    autoProjectStatusPageStartedLabel: 'Started',
    autoProjectStatusPageDescriptionLabel: 'Description',
    imageCollectionTabLabel: 'STEP 1: MODEL SETUP',
    imageCollectionTabRefineBtn: `${_MAIN_TITLES.manualRefinement.toUpperCase()}`,
    imageCollectionTabStartBTn: 'START TRAINING',
    classTitle: `${utilService.capitalize(_MAIN_TITLES.acClass)}`,
    trainingStatusTitle: 'Progress',
    collectingStatusTitle: 'status',
    trainingTabLabel: 'STEP 2: MODEL TESTING',
    pageNotFoundBtn: 'Back to Homepage',
    pageNotFoundContent: 'Sorry, page not found',
    autoProjectExitModalTitle: 'Attention: unsaved changes',
    autoProjectExitModalContent: 'We won’t be able to save your data if you move away from this page.',
    autoProjectExitModalBackBtn: 'GO BACK',
    autoProjectExitModalStayBtn: 'EXIT WITHOUT SAVING',
    autoProjectStopModalTitle: 'Stop Auto Modeling',
    autoProjectStopModalContent: 'Do you want to stop the Auto Modeling project? Note that once the project is stopped, it cannot be resumed and you will have to create a new project instead',
    autoProjectStopModalCancelBtn: 'CANCEL',
    autoProjectStopModalStopBtn: 'STOP',
    autoProjectProcessingAIDataBin: 'Processing AI Data',
    autoProjectReadyForFineTuneBin: 'Ready for Fine Tune',
    autoProjectReadyForTrainingBin: 'Ready for Training',
    dataCollectionMessage: 'Automatic data collection is in progress. It may take time to collect enough data to progress to the next step. Note that each class may have a different progress',
    readyForRefinementMessage: `Some of the ${_MAIN_TITLES.acClass}s are ready for fine tuning. Click "Fine Tune" to review the suggested images and select the ones that match the corresponding object. Do not worry, data is still being collected for the objects where data is still missing.`,
    refinementCompletedMessage: 'Data collection is still in progress. You will be notified as soon as there is enough data to start the training. ',
    readyForTrainingMessage: `Great news! There are enough ${_MAIN_TITLES.acClass}s ready for AI Analysis training (model creation).\n` +
        '\n' +
        `IMPORTANT! Only ${_MAIN_TITLES.acClass}s that have reached the “Ready for Training” status will be included in the AI Analysis. Rest of the ${_MAIN_TITLES.acClass}s will be disreguarded and removed from the project`,
    trainingInProgressMessage: 'Training is in progress. In parallel, more data is collected for future AI Analysis versions  ',
    trainingCompletedMessage: 'AI Analysis is ready! Review the “Training Status & Results” section for more details',
    projectStoppedMessage: 'The Auto Modeling project has stopped as it cannot procceed and find additional relevant data. Should you want to run the process again, please create a new project.',
    projectErrorMessage: 'An error occurred during the AI data processing. For support, please submit a ticket at TechSee Support Center https://support.techsee.me/.',
    collectingImagesClassStatus: 'Collecting images',
    readyForRefinementClassStatus: 'Ready for refinement',
    readyForTrainingClassStatus: 'Ready for training',
    trainingCompletedClassStatus: 'Training completed',
    cancelledClassStatus: 'Cancelled',
    trainingInProgressClassStatus: 'Training in progress',
    manualRefinementTitle: _MAIN_TITLES.manualRefinement,
    manualRefinementSubTitle: 'Choose all images that fit the reference images',
    manualRefinementCounterTitle: 'Selected images: ',
    manualRefinementExitModalTitle: 'Are you sure?',
    manualRefinementExitModalContent: `Note that by exiting without confirming the ${_MAIN_TITLES.acClass}, the work will be lost and will have to be reviewed again`,
    manualRefinementExitModalStayBtn: 'Yes',
    manualRefinementExitModalBackBtn: 'Cancel',
    manualRefinementDone: 'Refinement Done',
    somethingWentWrong: 'Something went wrong',
    somethingWentWrongSubTitle: 'Please contact your system administrator',
    autoExecuteTrainingTitle: 'AI Analysis Details',
    autoExecuteTrainingSubTitle: 'AI Analysis:',
    autoExecuteTrainingInput: 'AI Analysis',
    autoExecuteTrainingIncludedClassesTitle: `${utilService.capitalize(_MAIN_TITLES.acClass)}s included in the training:`,
    autoExecuteTrainingExcludedClassesTitle: `${utilService.capitalize(_MAIN_TITLES.acClass)}s excluded from the training:`,
    autoExecuteTrainingBtn: 'START TRAINING',
    autoExecuteTrainingCancelBtn: 'CANCEL',
    missingAiAnalysisNameInputError: 'Please provide AI Analysis name - it is mandatory',
    autoExecuteTrainingTooltipBeforePress: 'Training can be launched once enough data was collected',
    autoExecuteTrainingTooltipAfterPress: 'Automated training is running, please review the status section for more details',
    errorClassStatus: 'Error',
    createAutoProjectClasslistTitle: `${utilService.capitalize(_MAIN_TITLES.acClass)}s in this Project`,
    autoTrainingStatusPageClassesTitle: `${utilService.capitalize(_MAIN_TITLES.acClass)}s:`,
    incorrect: 'Incorrect',
    trainingHistory: 'Training History',
    loginFailed: 'Login failed. Contact support',
    poweredBy: 'powered by',
    login: 'Login',
    draft: 'Draft',
    predictionEvaluationsGtBtnHideText: `Hide ${_MAIN_TITLES.annotationsAnnotations}`,
    predictionEvaluationsGtBtnShowText: `Show ${_MAIN_TITLES.annotationsAnnotations}`,
    predictionEvaluationsPredListTitle: `${_MAIN_TITLES.predictions} list`,
    predictionEvaluationAnnotationsListTitle: `${_MAIN_TITLES.annotationsAnnotations} list`,
    moveToAnotherClassBeforeClassTitle: 'For class',
    projectsStatus: 'Status',
    autoProjectLaunchedStatus: 'Launched AI Analysis',
    autoProjectCompletedTraining: 'Completed Training',
    autoProjectInProgress: 'Processing AI Data',
    autoProjectInMr: 'Pending Fine Tune',
    autoProjectInTraining: 'Ongoing Training',
    autoProjectStooped: 'Manually Stopped',
    autoProjectError: 'Project with Errors',
    classInventoryTabTitle: `${utilService.capitalize(_MAIN_TITLES.acClass)}s Repository`,
    classInventoryTableClassFieldTitle: `${utilService.capitalize(_MAIN_TITLES.acClass)}`,
    classInventoryTableFilesCounterFieldTitle: 'Total Files',
    classInventoryTableNoClasses: 'Click "+" to start building the repository of objects for the Auto Generated projects',
    classInventoryTabName: `${utilService.capitalize(_MAIN_TITLES.acClass)}s`,
    randomImagesBtnTitle: 'Discover Data',
    regenerateTitle: 'Regenerate',
    availableClassesTitle: `Available ${utilService.capitalize(_MAIN_TITLES.acClass)}s`,
    backRandom: `back to ${utilService.capitalize(_MAIN_TITLES.acClass)}s`,
    addNewClassToolTip: `Add new ${utilService.capitalize(_MAIN_TITLES.acClass)}`,
    dataSourceEmpty: 'No images available. Contact your TechSee Account Manager to enable images collection.',
    dataSourceSelectInput: 'Data Source',
    whatsInTheDataTitle: 'What\'s in the data?',
    whatsInTheDataContent: 'These images represent patterns discovered in the account data sources. Add useful images to existing objects by using the \'+\' icon for the targeted object',
    whatsInTheDataNewBatchBtn: 'New Batch',
    whatsInTheDataNewBatchNoImagesTitle: 'No data to review',
    whatsInTheDataNewBatchNoImagesContent: 'There are currently not enough DATA for presenting images. Please contact support.',
    whatsInTheDataNewBatchEndImagesInBatchContent: 'Oh oh, we are left out of images… please click the "New Batch” button',
    WhatsInTheDataPendingFineTuneChip: 'Pending Fine-Tune',
    WhatsInTheDataDeleteSubClusterTitle: 'Are you sure?',
    WhatsInTheDataDeleteSubClusterContent: 'Are you sure you want to completely remove the cluster? This action cannot be undone',
    WhatsInTheDataDeleteSubClusterConfirmBtn: 'CONFIRM',
    WhatsInTheDataDeleteSubClusterCancelBtn: 'CANCEL',
    deleteClassSubTitle: 'By clicking delete, this class will be removed from the list, all the data will be deleted. Are you sure you want to proceed?',
    deleteClassConfirm: 'DELETE',
    deleteClassNotConfirm: 'CANCEL',
    dataSourceTitleCheckBox: 'Data source',
    dataTimeTitleCheckBox: 'Time Range',
    mrEmptyTitle: 'Not enough data to present'
};

export {_SYSTEM_TITLES, InsightsType};
